import { createContext, useContext, type ReactNode } from 'react';

const IncidentScopeContext = createContext<string | null>(null);

/**
 * Points every IAP card and hook below it at `incidentId` instead of the
 * workspace in the URL or Redux. Plan Library renders a plan's forms against
 * the plan's hidden template incident this way.
 */
export function IncidentScopeProvider({
  incidentId,
  children,
}: {
  incidentId: string;
  children: ReactNode;
}) {
  return (
    <IncidentScopeContext.Provider value={incidentId}>
      {children}
    </IncidentScopeContext.Provider>
  );
}

/** The scoped incident id, or null outside an `IncidentScopeProvider`. */
export function useIncidentScopeId(): string | null {
  return useContext(IncidentScopeContext);
}
